<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV12">
                    <div class="flexLayout">
                        <div style="width: 76px;"></div>
                        <div class="flexItem alignCenter grey20 bold font18r">{{title}}</div>
                        <div @click="close();" style="text-align:right; width: 76px;">
                            <i class="cancel-icon"></i>
                            <!-- <button class="button publishButton f12 white" :disabled="content===''"
                                @click="submit()">发表评论</button> -->
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 30px; padding-bottom: 24px;">
                    <div class="editingArea" style="margin-bottom:24px;">
                        <textarea class="f16 block w100p textbox roundBorder8 grey60"
                              style="background: hsla(0, 0%, 98%, 1)" :placeholder="placeholder"
                              v-model="content"></textarea>
                        <div class="alignRight grey60 font12r">
                            <span :class="{error:content.length>maxLength}">{{content.length}}</span>/{{maxLength}}
                        </div>
                    </div>

                    <div>
                        <button class="button publishButton f16" :disabled="content===''"
                            @click="submit()">{{submitText}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '@comp/part/drawerPart';

// platformApi
import requestManager   from '@comp/platformApi/requestManager';

// util
import consoleHelper from '@util/consoleHelper';
import objectHelper from '@util/objectHelper';
import appHelper from '@util/appHelper';

export default {
    name: "commentEditingDrawer",
    extends : drawerPart,
    props : {
        submitApiConfig : {
            type : Object,
            default : (()=>{
                return {
                    url : ''
                };
            })
        },
        id : {
            type : String
        },
        title : {
            type : String,
            default : '写评论~'
        },
        placeholder : {
            type : String,
            default : '写写这节课的心得吧~'
        },
        submitText : {
            type : String,
            default : '发表评论'
        },
        // isShow :{
        //     type : Boolean ,
        //     default : true
        // }
        // onSubmitSuccess : {
        //     type : Function
        // }
    },
    data() {
        return {
            content : '',
            maxLength : 100
        }
    },
    methods : {
        submit() {
            if (!this.content.length || this.content.length > this.maxLength)
            {
                consoleHelper.error('length: ' + this.content.length);
                return;
            }

            const url = this.submitApiConfig.url;
            const method = this.submitApiConfig.method || 'get';
            const dataPath = this.submitApiConfig.dataPath || 'data';
            const idName = this.submitApiConfig.idName || 'id';

            let data = {
                content : this.content
            };
            data[idName] = this.id;

            requestManager.request({
                url : url,
                method : method,
                data : data
            }, (error, result) => {
                if (error)
                {
                    consoleHelper.logError(error);
                    appHelper.showHint('出错了');
                    return;
                }

                appHelper.showHint('留言成功,审核通过后您可以看到您的留言!');
                this.content = '';
                this.close();
                let data = objectHelper.getDataByKeyPath(result, dataPath);
                this.onSubmitSuccess ? this.onSubmitSuccess(data) : null;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.publishButton {
    display: block;
    width: 100%;
    height: 42px;
    line-height: 42px;
    background: linear-gradient(90deg, #FFA929 0%, #FFB74D 100%);
    border-radius: 21px;
    border: none;
    color: white;
    &:disabled {
        opacity: 0.5;
    }
}
.editingArea {

    background: #FAFAFA;
    padding: 10px 14px;

    .textbox {
        min-height: 86px;
        background: transparent;
        border: none;
    }
}

.cancel-icon{
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAACQElEQVRYR+3YvaoTQRQH8HOGpLjVxcLCJ9AqYWZAK8FGr48giCD2NupFRVAUC4laWYsgNr6B+ASizGw2nZIXEK5gtrFIdo5ssbLsnezO10oE02b2zC9ndv4ZBmHHP7jjPvg3gZzzk8aYE3mef/sbHZ5MJqfH4/EPpdRRe75jHRRCnEfED0S0h4gzpdS9IZFCiKeI+AAAfm02mwt5nn9uzncMyDl/yRi7VQ8yxjzLsuz+EEghxAwRD+vaRDTTWt/tBEopzwCABoC9IZFCiOeIeKeBWa3X63OLxeJrJ7D6cjqdnh2NRh8BYH8IJOf8BWPsdgNSENGB1vpT7ztYDxgK6YOrLJ0xkxrpi+sFplzuEJwTMAUyFOcMjEHG4LyAIUgLbkVEl227dVvOev8Xu24cG64sy4vz+fyLT+h7A106mQrnvcTNX76tkwAwboXwKqRz9VxBHewK89byReGiOuiAjMYlAVZFhBBvEfFas3tE9EZrfcNnQ9jGRi1xVdCyIf7Mk+KoFgW0hTAAUMpTUDBwW5QQEaY8qgUB+3LONcxd3k9vYB8u9XnSC+iKS4l0BvriUiGdgKG4FMheYCwuFtkJTIWLQW4FpsaFIq3AoXAhSNvdzFVEfFcXI6KfZVketO9MXEK2a4wtzInoitb6ffM5293MY8bYw2pQhTPGXPI9prvi20hjzJMsyx51AqWU+0T0GgBOIeJNpVR1TzPYR0opiOgVAHwviuL6crksOoGDSQIL9+ZgYN1kj/0HxrZy5zv4GwSt9TgNU63GAAAAAElFTkSuQmCC);
}
</style>
